import React from 'react';

import TabAbout from './ProductAdditionalTabs/TabAbout';
import helpers from '../../helpers/helpers';

const ProductAdditional = ({
  descriptionInfo,
}) => {
  const { getTranslationText } = helpers;

  return (
    <div className="container">
      <div className="product__additional">
        <div className="product__additional__header">
          <h3>{getTranslationText('product.additional_info')}</h3>
        </div>
        <TabAbout
          descriptionInfo={descriptionInfo}
        />
      </div>
    </div>
  );
};

export default ProductAdditional;
